import { useAdminLang } from "./i18n";

// Converted 1:1 from the Xintra template (index.html, main-footer).
// #year is filled in by custom.js.
export default function AdminFooter() {
  const { t } = useAdminLang();

  return (
    <footer className="footer mt-auto py-3 bg-white text-center">
      <div className="container">
        <span className="text-muted">
          <span id="year"></span>
          {" "}{t("طراحی با")}{" "}
          <span className="bi bi-heart-fill text-danger"></span>
          {" "}{t("توسط")}{" "}
          <a href="https://www.rtl-theme.com/author/hogondesign/products/" target="_blank" rel="noreferrer">
            <span className="fw-medium text-primary">Xintra</span>
          </a>
        </span>
      </div>
    </footer>
  );
}
